export type ReportOrderPlacement = 'before' | 'after';

// Mirrors the engine's `move_ordered_item` so an optimistic order matches what
// the reorder request persists.
export function moveOrderedItem<T>(
    items: T[],
    isSource: (item: T) => boolean,
    isTarget: (item: T) => boolean,
    placement: ReportOrderPlacement,
): T[] {
    const source = items.find(isSource);
    const remainingItems = items.filter((item) => !isSource(item));
    const targetPosition = remainingItems.findIndex(isTarget);
    if (source === undefined || targetPosition < 0) {
        return [...items];
    }
    const insertionPosition = targetPosition + (placement === 'after' ? 1 : 0);
    return [
        ...remainingItems.slice(0, insertionPosition),
        source,
        ...remainingItems.slice(insertionPosition),
    ];
}
